// extracted by mini-css-extract-plugin
export default {"copy-history":"CopyHistory_copy-history__-K5XK"};